import fb from '@/api/firebase'
import di from '@/api/digital-interface'
import CsoRouter from '@/api/CsoRouter'
import store from '@/store'
import LoggingService from '@/common/LoggingService'
import MultipleTabs from '@/common/MultipleTabs'
import Session from '@/common/Session'
import Utils from '@/common/Utils'
import StaticUrls from '@/common/StaticUrls'
import PropertyService from '@/common/PropertyService'

export default class Authentication {
  static postfachLoginInProgress = false

  static teardownLocalSession () {
    store.clearAll()
    Session.stop()
  }

  static async forceLogoutForPostfachLogin () {
    if (Authentication.postfachLoginInProgress) {
      return
    }
    Authentication.postfachLoginInProgress = true
    try {
      MultipleTabs.register()
      if (di.token && !di.token.isAnonymous()) {
        await Authentication.logout({ redirect: false })
      }
    } finally {
      Authentication.postfachLoginInProgress = false
    }
  }

  static async login (params) {
    LoggingService.log(LoggingService.eventTypes.app, 'Login from Authentication class')
    const userAgent = Utils.getUserAgent()
    const firebasePromise = fb.getToken()
    if (params.code) {
      await di.v14.authenticateUserFromMagicLink({...params, ...userAgent})
    } else if (params.username) {
      await di.v14.authenticateUserFromCredentials({...params, ...userAgent})
    }
    if (params.middleware) {
      await params.middleware()
    }
    store.clearAll()
    MultipleTabs.update()
    await store.fetchVertragsliste()
    if (params.username && store.hasGP) {
      firebasePromise.then(token => token && di.v14.updatePushregistrierung(token, userAgent.browser))
    }
    CsoRouter.isOpenArea = false
    const deeplink = CsoRouter.findInRoutes('/' + CsoRouter.router?.currentRoute?.value?.params?.deepLink)
    const userPopup = di.token.isSource('KSO_DB') ? 'true' : undefined
    const domainPopup = di.token.username.includes('@energie.check24.de') ? 'true' : undefined
    store.setAfterLoginHook(true)
    if (deeplink) {
      CsoRouter.router.push({ path: deeplink.path, query: { userPopup, domainPopup } })
    } else {
      CsoRouter.router.push({ name: 'dashboard', query: { userPopup, domainPopup } })
    }
  }

  static async logout (params) {
    LoggingService.log(LoggingService.eventTypes.app, 'Logout from Authentication class')
    const redirect = PropertyService.isPrd() ? StaticUrls.logoutPage : StaticUrls.login
    if (di.token && !di.token.isAnonymous()) {
      Utils.windowLoading(true)
      await di.v14.deauthenticate()
      Authentication.teardownLocalSession()
      MultipleTabs.update()
      di.resetParentLogId()
      await di.v14.authenticateAnonymous()
      CsoRouter.isOpenArea = true
      Utils.windowLoading(false)
    }
    if (params?.redirect !== false) {
      window.location.href = redirect
    }
  }
}
